import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Select, Space, Modal, Form } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from "../../js/permission"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select

const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 16 }
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type fetchParams = {
    food_type_id: undefined | string,
    food_item_name: string | undefined,
}

type food = {
    "food_type_id": string,
    "food_type_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        food_type_id: undefined,
        food_item_name: undefined
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [data, setData] = useState<any>([])

    const [useUnit, setUseUnit] = useState<string>()
    const [buyUnit, setBuyUnit] = useState<string>()
    const [useExchangeVal, setUseExchangeVal] = useState<string>()
    const [buyExchangeVal, setBuyExchangeVal] = useState<string>()

    const [bmData, setBmData] = useState<food[]>([])

    const [recordInVisible, setRecordInVisible] = useState<boolean>(false)
    const [activeRecord, setActiveRecord] = useState<{ id: string, no_yet_pay_amount?: number, user_name?: string } | undefined>()
    const [form] = Form.useForm()

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        baseAxiosNoInfo('/cooking_center/global/food_type_list').then((res: any) => {
            setBmData(res)
        })
    }, [])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        axiosTable.get('/cooking_center/food_item/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const onFinish = (value: any) => {
        if (activeRecord) {
            baseAxiosComplete.post('/cooking_center/food_item/update', {
                food_item_id: activeRecord.id,
                food_item_name: value.food_item_name,
                food_item_code: value.food_item_code,
                food_type_id: value.food_type_id,
                is_seasoning: value.is_seasoning,
                use_unit: value.use_unit,
                buy_unit: value.buy_unit,
                use_exchange_val: useExchangeVal,
                buy_exchange_val: buyExchangeVal
            }).then((res: any) => {
                if (res.status === 0) {
                    fetch({ pagination, fetchOtherParams: fetchOtherParamsTmpl })
                    setRecordInVisible(false)
                }
            })

        } else {
            baseAxiosComplete.post('/cooking_center/food_item/add', {
                food_item_name: value.food_item_name,
                food_item_code: value.food_item_code,
                food_type_id: value.food_type_id,
                is_seasoning: value.is_seasoning,
                use_unit: value.use_unit,
                buy_unit: value.buy_unit,
                use_exchange_val: useExchangeVal,
                buy_exchange_val: buyExchangeVal
            }).then((res: any) => {
                if (res.status === 0) {
                    fetch({ pagination, fetchOtherParams: fetchOtherParamsTmpl })
                    setRecordInVisible(false)
                }
            })
        }
    }

    let scOptions = bmData.map((el: any) => (<Option value={el.food_type_id} key={el.food_type_id}>{el.food_type_name}</Option>))

    return (<div className="common-page">
        {/* 膳食中心 -> 菜品管理 -> 食材管理 */}
        <BreadCrumb position={['膳食中心', '食材管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="食材分类" value={fetchOtherParams.food_type_id} onChange={(v: string) => {
                    let f = { ...fetchOtherParams }
                    f.food_type_id = v
                    setFetchOtherParams(f)
                }} >
                    {scOptions}
                </Select>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="食材名称" value={fetchOtherParams.food_item_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'food_item_name') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes("添加") && <Button type="primary" style={{ marginRight: 12, marginBottom: 12 }} onClick={() => {
                    form.setFieldsValue({
                        food_item_name: undefined, // 食材名称
                        food_item_code: undefined, // 物料编号（英文+数字）
                        food_type_id: undefined, // 食材分类id，“全局-查询食材分类下拉列表”接口返回的food_type_id字段
                        is_seasoning: undefined, // 是否调料品 1是 0否
                        use_unit: undefined, // 用料单位，例如 克
                        buy_unit: undefined, // 采购单位，例如 包
                    })

                    setUseExchangeVal(undefined)
                    setBuyExchangeVal(undefined)

                    setRecordInVisible(true)
                    setActiveRecord(undefined)
                }}>添加</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="food_item_id" pagination={pagination} onChange={handleTableChange}>
                <Column title="物料编号" dataIndex="food_item_code" key="food_item_code" />
                <Column title="食材名称" dataIndex="food_item_name" key="food_item_name" />
                <Column title="食材分类" dataIndex="food_type_name" key="food_type_name" />
                <Column title="用料单位" dataIndex="use_unit" key="use_unit" />
                <Column title="采购单位" dataIndex="buy_unit" key="buy_unit" />
                <Column title="单位换算" dataIndex="exchange_use_to_buy" key="exchange_use_to_buy" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            {permission.includes('编辑') &&
                                <Button onClick={() => {
                                    baseAxiosNoInfo('cooking_center/config/food_item/detail', {
                                        params: {
                                            food_item_id: record.food_item_id
                                        }
                                    }).then((res: any) => {
                                        form.setFieldsValue({
                                            food_item_name: res.food_item_name,//食材名称，不允许重复
                                            food_item_code: res.food_item_code,//物料编号（英文+数字），不允许重复
                                            food_type_id: res.food_type_id,//食材分类id，“全局-查询食材分类下拉列表”接口返回的food_type_id字段
                                            is_seasoning: res.is_seasoning,//是否调料品 1是 0否，整数类型
                                            use_unit: res.use_unit,//用料单位，例如 克
                                            buy_unit: res.buy_unit,//采购单位，例如 包
                                        })

                                        setUseUnit(res.use_unit)
                                        setBuyUnit(res.buy_unit)

                                        setUseExchangeVal(res.use_exchange_val)
                                        setBuyExchangeVal(res.buy_exchange_val)

                                        setRecordInVisible(true)
                                        setActiveRecord({ id: record.food_item_id })
                                    })
                                }} >编辑</Button>}
                        </Space>)
                    }}
                />
            </Table>
        </div>

        {/* 膳食中心 -> 菜品管理 -> 食材管理 -> 新增或编辑 */}
        <Modal title={activeRecord ? '编辑' : '添加'} visible={recordInVisible} footer={false} onCancel={() => { setRecordInVisible(false) }}>
            <Form  {...formItemLayout} form={form} onFinish={onFinish} >
                <Form.Item label="食材名称" name="food_item_name" rules={[{ required: true, message: '必须填写食材名称，限20个字内' }]}>
                    <Input />
                </Form.Item>

                <Form.Item label="食材分类" name="food_type_id" rules={[{ required: true, message: '必须选择食材分类' }]}>
                    <Select virtual={false} >
                        {scOptions}
                    </Select>
                </Form.Item>

                <Form.Item label="是否调料品" name="is_seasoning" rules={[{ required: true, message: '必须选择是否调料品' }]}>
                    <Select virtual={false} >
                        <Option value={1} key="1">是</Option>
                        <Option value={0} key="0">否</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="用料单位" name="use_unit" rules={[{ required: true, message: '必须填写用料单位' }]}>
                    <Input onChange={(e: any) => {
                        setUseUnit(e.target.value)
                    }} />
                </Form.Item>

                <Form.Item label="采购单位" name="buy_unit" rules={[{ required: true, message: '必须填写采购单位' }]}>
                    <Input onChange={(e: any) => {
                        setBuyUnit(e.target.value)
                    }} />
                </Form.Item>

                <Form.Item label="单位换算" >
                    <div className="clear">
                        <Input className="fl" style={{ width: 100, marginRight: 10 }} value={useExchangeVal} onChange={(e: any) => {
                            setUseExchangeVal(e.target.value)
                        }} />
                        <span className="fl" style={{ marginRight: 10 }}>{useUnit} = </span>

                        <Input className="fl" style={{ width: 100, marginRight: 10 }} value={buyExchangeVal} onChange={(e: any) => {
                            setBuyExchangeVal(e.target.value)
                        }} />
                        <span className="fl" style={{ marginRight: 10 }} >{buyUnit}</span>
                    </div>
                </Form.Item>

                <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}